import { makeHtmlNodeToLatexPrinter, textNodeToLatexPrinter, makeHtmlNodeToJsxPrinter, textNodeToJsxPrinter, allHtmlParsers, parseChildren } from '@utils/ast';
import { video23AudioToLatexPrinters, video23AudioPrinters, video23AudioParsers } from './spec.23video.audio.js';
import { video23ToLatexPrinters, video23Printers, video23Parsers } from './spec.23video.video.js';
import { boxToLatexPrinters, boxPrinters, boxParsers } from './spec.box.js';
import { fontToLatexPrinters, fontPrinters, fontParsers } from './spec.font.js';
import { imageToLatexPrinters, imagePrinters, imageParsers } from './spec.image.js';
import { linkToLatexPrinters, linkPrinters, linkParsers } from './spec.link.js';
import { medialibraryToLatexPrinters, medialibraryPrinters, medialibraryParsers } from './spec.medialibrary.js';

const parseIGuideHtmlNode = (node, context) => {
  const attributes = Object.fromEntries(Array.from(node.attributes).map(it => [it.nodeName, it.nodeValue]).filter(it => it[1] !== null));
  const children = parseChildren(node, {
    ...iGuideHtmlNodeParsers,
    ...video23Parsers,
    ...video23AudioParsers,
    ...medialibraryParsers,
    ...boxParsers,
    ...imageParsers,
    ...fontParsers,
    ...linkParsers
  }, context.depth + 1, {
    context: context.extra
  });
  const tagName = node.tagName.toLowerCase();
  const transformedTagName = (() => {
    switch (tagName) {
      // Add a parser that can transform legacy
      // <a class="flowplayer-..." />-tags used to embed audio and video files
      // into modern <audio />- and <video/>-tags.
      case "a":
        if (node.classList.contains("flowplayer-video")) {
          return "video";
        }
        if (node.classList.contains("flowplayer-audio")) {
          return "audio";
        }
        break;

      // downgrade h1,h2,h3 tags to h4 in order to ensure that heading levels
      // are WCAG-compliant, as h1-h3 are reserved for other use-cases in the
      // frontend
      case "h1":
      case "h2":
      case "h3":
        return context.extra?.["allowAllHeadings"] ? tagName : "h4";
    }
    return tagName;
  })();
  if (node.matches(".richtext--image-wrapper")) {
    const imageNode = node.querySelector("img");
    const captionNode = node.querySelector(".richtext--image-caption");
    const parsedImageNode = imageNode ? imageParsers.img(imageNode, context) : undefined;
    if (parsedImageNode) {
      return {
        ...parsedImageNode,
        caption: captionNode ? parseIGuideHtmlNode(captionNode, context) ?? undefined : undefined
      };
    }
  }
  if (transformedTagName === "table") {
    attributes["data-avoid-break-inside"] = "true";
  }
  return {
    nodeType: "html",
    tagName: transformedTagName,
    attributes: Object.keys(attributes).length > 0 ? attributes : undefined,
    children: children.length > 0 ? children : undefined
  };
};
const iGuideHtmlNodeParsers = {
  ...Object.fromEntries(Object.keys(allHtmlParsers).map(key => [key, parseIGuideHtmlNode])),
  iframe: parseIGuideHtmlNode
};
const htmlNodeToJsxPrinter = makeHtmlNodeToJsxPrinter(undefined, () => ({
  ...iGuideHtmlNodeJsxPrinters,
  ...video23Printers,
  ...video23AudioPrinters,
  ...medialibraryPrinters,
  ...boxPrinters,
  ...imagePrinters,
  ...fontPrinters,
  ...linkPrinters
}));
const iGuideHtmlNodeJsxPrinters = {
  text: textNodeToJsxPrinter,
  html: htmlNodeToJsxPrinter
};
const htmlNodeToLatexPrinter = makeHtmlNodeToLatexPrinter(() => ({
  ...iGuideHtmlNodeLatexPrinters,
  ...video23ToLatexPrinters,
  ...video23AudioToLatexPrinters,
  ...medialibraryToLatexPrinters,
  ...boxToLatexPrinters,
  ...imageToLatexPrinters,
  ...fontToLatexPrinters,
  ...linkToLatexPrinters
}));
const iGuideHtmlNodeLatexPrinters = {
  text: textNodeToLatexPrinter,
  html: htmlNodeToLatexPrinter
};

export { htmlNodeToJsxPrinter, htmlNodeToLatexPrinter, iGuideHtmlNodeJsxPrinters, iGuideHtmlNodeLatexPrinters, iGuideHtmlNodeParsers, parseIGuideHtmlNode };
//# sourceMappingURL=spec.html.js.map
